document.addEventListener('DOMContentLoaded', function () {
  const productSustainabilityCarousel = {
    selector: '.product-sustainability-carousel',
    init: function () {
      this.slider();
    },
    slider: function () {
      let obj = this;
      const carouselDiv = $(`${this.selector}`);
      if ($(`${this.selector}`).length > 0) {
        $(`${this.selector}`).each(function () {

          if ($(this).find('.swiper-container').hasClass('swiper-container-initialized')) return;
          
          const bulletMessage = this.querySelector('.swiper-container').getAttribute('data-pagination-bullet-message');
          const activeNodes = this.querySelectorAll(`${obj.selector} .swiper-slide`);
          const pagination = activeNodes.length > 1
            ? {
              clickable: true,
              el: '.swiper-pagination',
              type: 'bullets',
              dynamicBullets: true,
              dynamicMainBullets: 5
            }
            : false
            ;
          const autoplay = activeNodes.length > 1
            ? {
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
              waitForTransition: false,
            }
            : false
            ;

          const a11y = { paginationBulletMessage: bulletMessage };

          let swiper = new Swiper(this.querySelector(`${obj.selector} .swiper-container`), {
            init: false,
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: true,
            freeMode: true,
            mousewheel: true,
            keyboard: true,
            mousewheel: false,
            pagination,
            autoplay,
            a11y,
          });

          let isPlaying = true;

          document.addEventListener('sustainability-carousel-button-click', function () {
            if (isPlaying) {
              swiper.autoplay.stop();
              isPlaying = false;
            } else {
              swiper.autoplay.start();
              isPlaying = true;
            }
          });

          swiper.init();

        });
      }
    }
  };

  productSustainabilityCarousel.init();
});